var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8236 7.24373C14.9948 4.36998 12.319 2.71539 9.50065 2.71539C8.09148 2.71539 6.7219 3.12706 5.47107 3.89498C4.22023 4.67081 3.09607 5.80289 2.17773 7.24373C1.38607 8.48664 1.38607 10.5054 2.17773 11.7483C4.00648 14.63 6.68232 16.2766 9.50065 16.2766C10.9098 16.2766 12.2794 15.865 13.5302 15.0971C14.7811 14.3212 15.9052 13.1891 16.8236 11.7483C17.6152 10.5133 17.6152 8.48664 16.8236 7.24373ZM9.50065 12.6983C7.72732 12.6983 6.30232 11.2654 6.30232 9.49998C6.30232 7.73456 7.72732 6.30164 9.50065 6.30164C11.274 6.30164 12.699 7.73456 12.699 9.49998C12.699 11.2654 11.274 12.6983 9.50065 12.6983Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50039 7.23584C8.25747 7.23584 7.24414 8.24917 7.24414 9.50001C7.24414 10.7429 8.25747 11.7563 9.50039 11.7563C10.7433 11.7563 11.7646 10.7429 11.7646 9.50001C11.7646 8.25709 10.7433 7.23584 9.50039 7.23584Z",
    fill: "#292D32"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.b407d320.svg";
export { ForwardRef as ReactComponent };